const makeComparator = (equalValue, greaterValue, smallerValue) => (x, y) =>
  x === y ? equalValue : x > y ? greaterValue : smallerValue;

export default makeComparator;
